<style scoped>
@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 174, 239, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 174, 239, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 174, 239, 0);
  }
}

.account-verified {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: calc(100vh - 68px);
  position: relative;
}

.account-verified__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.account-verified__button {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 48%;
  height: 80px;
  background-color: #ffffff;
  border: 2px solid #b3d4fc;
  border-radius: 10px;
  color: #0f3964;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.3s ease-in-out;
  min-height: 150px;
}

.account-verified__button:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transform: translateY(-5px);
}

.account-verified__button:hover::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 80%);
  animation: pulse 1.5s ease-out infinite;
}

.account-verified__icon {
  font-size: 32px;
  margin-bottom: 8px;
}
.account-verified__footer{
  width: calc(100% + 30px);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
  position: relative;
  overflow: hidden;
  background-color: #071b31;
}
.account-verification__image{
  position: absolute;
  left: 40px;
  bottom: 120px;
  border-radius: 16px;
  width: 320px;
  height: 192px;
  z-index: 1;
}

.account-verification__dotted-pattern{
  position: absolute;
  left: 5px;
  bottom: -50px;
}

.account-verified--success,
.account-verified--failure,
.account-verified--loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
}
</style>


<template>
  <div class="account-verified">
    <div v-if="isLoading" class="account-verified--loading">
      <h2>Verifying your account...</h2>
      <p>Please wait while we verify your account.</p>
    </div>
    <div v-else-if="isVerified" class="account-verified--success">
      <h2>You have successfully registered for an Anchor Account!</h2>
      <div class="account-verified__container">
        <button class="account-verified__button" @click="toSubmitNewDeal">
          <FontAwesomeIcon  class="account-verified__icon" icon="handshake"/>
              Submit a new Deal
        </button>
        <button class="account-verified__button" @click="toGuarantor">
          <FontAwesomeIcon class="account-verified__icon" icon="file-signature"/>
          Let's complete your application
        </button>
      </div>
    </div>
    <div v-else class="account-verified--failure">
      <h2>Oops! Something went wrong.</h2>
      <p>We could not verify your account...</p>
      <button class="account-verified__button" @click="resendVerification">
          Resend Verification Email
      </button>
    </div>
    <b-img src="./static/base/new-construction.png" class="account-verification__image" />
    <div class="account-verified__footer">
      <b-img src="./static/base/dots-pattern.svg" class="account-verification__dotted-pattern" />
    </div>
  </div>
</template>


<script>
import { LOGIN, LOGOUT } from '@/vuex/types/actions';
import userVerificationMixin from '@/components/utils/verification/verification';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faHandshake,
} from '@fortawesome/free-solid-svg-icons';

library.add([
  faHandshake,
]);

export default {
  mixins: [userVerificationMixin],
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      isVerified: false,
      isLoading: true,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    alreadyVerified() {
      return this.user && this.user.verified === true;
    },
  },
  methods: {
    toGuarantor() {
      this.$router.push({ name: 'Guarantor' });
    },
    toSubmitNewDeal() {
      this.$router.push({ name: 'NewDeal' });
    },
    logInUser() {
      this.$reqs.get(`/users/${this.user.id}`)
        .then((response) => {
          this.$store.dispatch(LOGIN, response.data);
        })
        .catch(() => this.$store.dispatch(LOGOUT));
    },
  },
  created() {
    const userId = this.$route.params.id;
    const token = this.$route.params.token;
    const linkFromAnotherUser = this.user && this.user.id !== parseInt(userId, 10);

    if (!userId || !token || linkFromAnotherUser) {
      this.$router.push({ name: this.user ? 'Dashboard' : 'Index' });
      return;
    }

    if (this.alreadyVerified) {
      this.toDashboard();
      return;
    }

    this.$reqs
      .get(`/users/${userId}/verify?token=${token}`, null, { error: false })
      .then(() => {
        this.isVerified = true;
        this.isLoading = false;
        this.logInUser();
      }).catch(() => {
        this.isVerified = false;
        this.isLoading = false;
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/general/AccountConfirmation.vue